<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27">
    <g fill="none" fill-rule="evenodd">
      <ellipse cx="14" cy="13.5" rx="14" ry="13.5" />
      <path
        fill="#FFF"
        d="M12.635 19.384a.853.853 0 0 1-.623-.265l-3.884-4.2a.976.976 0 0 1-.03-1.352.87.87 0 0 1 1.29-.031l2.847 2.13a.36.36 0 0 0 .548-.061l6.747-8.742a.876.876 0 0 1 1.275-.186c.4.31.49.917.178 1.337l-7.621 10.98a.898.898 0 0 1-.652.374c-.03.016-.045.016-.075.016z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'GreenCheck'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

ellipse {
  fill: $secondary;
}
</style>
